import React, { Component,Fragment } from 'react';
import Breadcrumb from "../../common/breadcrumb"
import queryString from "query-string";
import { getObject, updateObject, listItems, packData } from "../../api";
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { FlowDataEntry } from '../../common/flowDataEntry'
import Editor from "../../common/quillEditor";

export class TUserEdit extends Component {
    constructor(props) {
        super(props)
        const value=queryString.parse(this.props.location.search);
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleHookChange = this.handleHookChange.bind(this);

        this.state = {
            loading: true,
            pid: value.pid,
            data: {},
        }
    }

    //image upload
    _handleSubmit(e, values) {
        e.preventDefault();

        console.log(values);
    }

    handleContentChange = (value) => {
        this.setState({
            data: { ...this.state.data, content: value }
        });
    }

    handleHookChange = (value) => {
        this.setState({
            data: { ...this.state.data, hook: value }
        });
    }

    imageUrlUpdated = (event) => {       
        this.setState( {data: {...this.state.data, imageUrl: event.target.value}});
    }

    onValidSubmit = (event, values) => {
        const formData = new FormData(document.getElementById('mainForm'));
        this.onSaveTuser(formData);
    };
    
    onValidSubmit = (event, values) => {
        const formData = new FormData(document.getElementById('mainForm'));
        packData(formData, this.state.data);
        this.onSaveTuser(formData);
    };
    
    onInvalidSubmit = (event, errors, values) => {
        this.setState({errors, values});
    };

    onSaveTuser = (values) => {        
        updateObject('tuser', values, this.state.pid, ).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.loadTuser();
            }
        });
    };

    loadTuser = () => {
        this.setState({ loading: true});
        if (this.state.pid) {
            getObject('tuser', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTuser();        
    }

    render() {
        const defaultValues = this.state.data;

        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       
        return (
            <Fragment>
                <Breadcrumb title="Edit Tuser" parents={[{name: "Tuser List", url: "/admin/tuser/list"}]} />

                <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={defaultValues}>
                    <FlowDataEntry >

                        <Fragment>
                            <AvField label="Name" grid={{xs: 10}} name="fullname" id="fullname" type="text" />
                            <AvField label="Display Name" grid={{xs: 10}} name="displayname" id="displayname" type="text" />
                            <AvField label="Email" grid={{xs: 10}} name="email" id="email" type="text" />
                            <AvField label="Phone" grid={{xs: 10}} name="phone" id="phone" type="text" />
                            <AvField label="WP Email" grid={{xs: 10}} name="wpEmail" id="wpEmail" type="text" />
                            <AvField label="Password" grid={{xs: 10}} name="password" id="password" type="text" />
                            <AvField label="Status" grid={{xs: 10}} name="status" id="status" type="select">                                 
                                <option disabled value="">Select Status</option>                                 
                                <option value="draft" key="draft">Draft</option>                                 
                                <option value="private" key="private">Private</option>                                                             
                                <option value="publish" key="publish" >Publish</option>                                 
                                <option value="inactive" key="inactive" >Inactive</option>                                                        
                            </AvField>
                            <AvField label="First Name" grid={{xs: 10}} name="firstname" id="firstname" type="text" />
                            <AvField label="Last Name" grid={{xs: 10}} name="lastname" id="lastname" type="text" />
                            <AvField label="Permissions" grid={{xs: 10}} name="permissions" id="permissions" type="text" value={listItems(this.state.data.permissions)}/>
                        </Fragment>

                        <Fragment>
                            <AvField label="Billing Street" grid={{xs: 10}} name="billStreet" id="billStreet" type="text" />
                            <AvField label="Billing City" grid={{xs: 10}} name="billCity" id="billCity" type="text" />
                            <AvField label="Billing State" grid={{xs: 10}} name="billState" id="billState" type="text" />
                            <AvField label="Billing Zip" grid={{xs: 10}} name="billPostalCode" id="billPostalCode" type="text" />
                            <AvField label="Billing Country" grid={{xs: 10}} name="billCountry" id="billCountry" type="text" />
                        </Fragment>

                        <Fragment>
                            <AvField label="Shipping Street" grid={{xs: 10}} name="shipStreet" id="shipAddress" type="text" />
                            <AvField label="Shipping City" grid={{xs: 10}} name="shipCity" id="shipCity" type="text" />
                            <AvField label="Shipping State" grid={{xs: 10}} name="shipState" id="shipState" type="text" />
                            <AvField label="Shipping Zip" grid={{xs: 10}} name="shipZip" id="shipZip" type="text" />
                            <AvField label="Shipping Country" grid={{xs: 10}} name="shipCountry" id="shipCountry" type="text" />
                        </Fragment>

                        <Editor 
                            hook={defaultValues.hook}
                            content={defaultValues.content}
                            onHookChange={this.handleHookChange}
                            onContentChange={this.handleContentChange}
                        />

                        <Fragment>                    
                            <AvField label="Image Url" grid={{xs: 10}} name="imageUrl" id="imageUrl" type="text" onBlur={(e) => this.imageUrlUpdated(e)}/>
                            <div className="row">
                                <div className="col-sm-2">
                                </div>
                                <div className="col-sm-10">  
                                    <img src={defaultValues.imageUrl}  style={{border:"1px solid #021a40", height:200}} alt="" />
                                </div>
                            </div>
                        </Fragment>

                    </FlowDataEntry>
                </AvForm>
            </Fragment>
        )
    }
}
}
export default TUserEdit

